/** Hidden root (99) masquerades as Super Admin (7) in the UI. */
export const effectiveUserType = (raw = localStorage.getItem("userType")) => {
  const t = String(raw ?? "");
  if (t === "99") return "7";
  return t;
};

export const isSuperAdminUi = (raw) => effectiveUserType(raw) === "7";

export const roleLabel = (raw) => {
  const t = effectiveUserType(raw);
  if (t === "7") return "Super Admin";
  if (t === "6") return "Admin";
  if (t === "5") return "Mini Admin";
  if (t === "4") return "Master";
  if (t === "3") return "Super Master";
  if (t === "2") return "Agent";
  return "Client";
};
